import React, {Component} from 'react';
import '../../css/components/Footer.css'
import PropTypes from "prop-types";


class Footer extends Component {

    handleChange = event => {
        this.props.handleCurrencyChange(event.target.value);
    };

    render() {
        return (
            <table id={"footerTable"}>
                <tbody>
                <tr>
                    <td id={"companyName"} style={{justifyContent: "center"}}>
                        © Riad Remmy, {new Date().getFullYear()}
                    </td>
                </tr>
                </tbody>
            </table>
        );
    }
}


Footer.propTypes = {
    currency: PropTypes.string.isRequired,
    handleCurrencyChange: PropTypes.func.isRequired
};

export default Footer;

